import ApiClient from '@/api/client.js';
import { getUploadProgress } from '@/utils/requests.js';

const path = require('path');

class FileUploadAPI extends ApiClient {
  constructor() {
    super();
  }

  /** CREATE */
  async createFileUploadFormat(data) {
    const response = await this.post(this.FILE_UPLOAD_API_APTH, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }
  async createFileUploadFile(id, file) {
    const route = path.join(
      process.env.VUE_APP_RESOURCE_API_PATH,
      `file-upload/${id}/`
    );
    const response = await this.put(route, file, {
      onUploadProgress: (progressEvent) => { getUploadProgress(progressEvent); }
    });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  /** UPDATE */
  async updateFileUploadFormat(location, data) {
    const response = await this.patch(location, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async updateFileUploadFile(location, file) {
    const response = await this.put(location, file, {
      onUploadProgress: (progressEvent) => { getUploadProgress(progressEvent); }
    });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async updateFileUploadResource(id, data, async = true) {
    const route = path.join(
      process.env.VUE_APP_RESOURCE_API_PATH,
      `file-upload/${id}/?asynchrone=${async}`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  /** DELETE */
  async deleteFileUploadFile(id) {
    const route = path.join(
      process.env.VUE_APP_RESOURCE_API_PATH,
      `file-upload/${id}/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return response.data;
    }
    return false;
  }

  /** SCENARIO */
  async runFileUploadResourceScenario(id, scenarioId, data) {
    const route = path.join(
      process.env.VUE_APP_RESOURCE_API_PATH,
      `file-upload/${id}/_scenarios/${scenarioId}/run/?asynchrone=true`
    );
    const response = await this.post(route, data);
    if (response.status === 202) {
      return response.data;
    }
    return false;
  }

  /** ANNEXES */
  async createFileUploadResourceAnnexe(id, data) {
    const route = path.join(
      process.env.VUE_APP_RESOURCE_API_PATH,
      `file-upload/${id}/?asynchrone=false`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  // async updateFileUploadAnnexe(resourceId) {
  //   const route = new URL(path.join(`${i18n.locale}${process.env.VUE_APP_RESOURCE_API_PATH}`, `resources/${resourceId}/`), DOMAIN);
  //   const response = await this.patch(route, {} );
  //   if (response.status === 200) {
  //     return response.data;
  //   }
  //   return false;
  // }
};

const fileUploadAPI = new FileUploadAPI();
export default fileUploadAPI;